import { useSelector } from 'react-redux';
import { resumeSlice, ResumeState } from '../state/slice/resumeSlice';
import { AppDispatch, RootState, useAppDispatch } from '../state/store';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useResume = () => {
  const dispatch: AppDispatch = useAppDispatch();
  const resume = useSelector<RootState, ResumeState>((state) => state.resume);
  const { saveSentenceId } = resumeSlice.actions;
  const { saveTrainingId } = resumeSlice.actions;

  return {
    resume,
    saveSentenceId: (state: string) => dispatch(saveSentenceId(state)),
    saveTrainingId: (state: number) => dispatch(saveTrainingId(state)),
  };
};
export default useResume;
